module.exports = __webpack_public_path__ + "img/_Small-Semi-Elliptical-Attachment-R.19d2a4c1.jpg";